//LOADER USE BEFORE MAKING API CALL
const Loader = () => {
    return <div className="app-spinner"></div>;
  };

export default Loader;